import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'wil-landing-static-sections',
  standalone: true,
  templateUrl: './landing-static-sections.component.html',
  styleUrl: './landing-static-sections.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class LandingStaticSectionsComponent {}
